import React, { useState } from 'react'
import { useTranslation } from 'i18n'

import { CSSTransition } from 'react-transition-group'

import ShareIcons from 'components/ShareIcons'

import ChecklistItem from './components/ChecklistItem'
import ChecklistResult from './components/ChecklistResult'

import './ChecklistStep3.scss'

const ChecklistStep = ({
  brk,
  breakId,
  step,
  onEngage = function () {},
  onAwardPoints = function () {},
  onChangeBackground = function () {},
  service,
  nextStepButton,
  skipButton,
}) => {
  const { t } = useTranslation('checklist')
  const checklist = step && step.checklist
  const [checklistResult, setChecklistResult] = useState(false)
  let checkedItemsList = []

  const animationDuration = 800

  const socialShareComponent = step.socialShareOn && (
    <ShareIcons
      facebookShare={step.facebookShare}
      twitterShare={step.twitterShare}
      pinterestShare={step.pinterestShare}
      emailShare={step.emailShare}
      emailConfig={{
        subject: step.shareEmailSubject,
        body: step.shareEmailBody,
      }}
      copyShare={step.copyShare}
      whatsappShare={step.whatsappShare}
    />
  )

  const handleSubmit = async () => {
    onEngage()
    onAwardPoints()

    const checkedCount = checkedItemsList.length

    const result = checklist.results.find(element => {
      if (element.minChecked !== null && element.minChecked !== null) {
        return (
          checkedCount >= element.minChecked &&
          checkedCount <= element.maxChecked
        )
      }
      return false
    })

    setChecklistResult(result)
  }

  const handleClickCheckbox = (checked, id, label) => {
    if (checked) {
      checkedItemsList.push(id)
    } else {
      const index = checkedItemsList.indexOf(id)
      if (index > -1) {
        checkedItemsList.splice(index, 1)
      }
    }
  }

  return (
    <section className="checklist-step3">
      <div
        className={`step-content xx-todo-xx-with-shadow ${
          brk?.navigationType === 'TOP' ? 'top-navigation' : ''
        }`}
      >
        {
          <>
            <div className="step-intro step-subcopy">
              {/* <h1>{checklist.introCopy}</h1> */}
              <div dangerouslySetInnerHTML={{ __html: checklist.bodyCopy }} />
            </div>
            <div className={`checklist-wrap checklist-wrap--regular`}>
              {checklist &&
                checklist.itemGroups &&
                checklist.itemGroups.map((item, i) => {
                  const { id, title, description, imageType, image } =
                    item.items[0]

                  return (
                    <ChecklistItem
                      key={i}
                      id={id}
                      title={title}
                      description={description}
                      imageType={imageType}
                      imageUrl={
                        image
                          ? `${process.env.SITE_ASSET_URL}/${image.id}`
                          : null
                      }
                      imageAlt={image ? image.altAttribute : null}
                      disabled={false}
                      onClick={handleClickCheckbox}
                    />
                  )
                })}
            </div>
            <CSSTransition
              in={!checklistResult}
              timeout={animationDuration}
              classNames="exit-fadeout"
            >
              <div className="submit-container">
                <input
                  type="submit"
                  className="btn"
                  disabled={checklistResult}
                  value={t('seeMyResult')}
                  onClick={handleSubmit}
                />
              </div>
            </CSSTransition>
          </>
        }

        <CSSTransition
          in={!!checklistResult}
          timeout={animationDuration}
          classNames="enter-fadein"
        >
          {checklistResult ? (
            <ChecklistResult
              headline={checklistResult.headline}
              text={checklistResult.text}
              imageUrl={
                checklistResult.image
                  ? `${process.env.SITE_ASSET_URL}/${checklistResult.image.id}`
                  : null
              }
              imageAlt={
                checklistResult.image
                  ? checklistResult.image.altAttribute
                  : null
              }
              shareIcons={socialShareComponent}
            />
          ) : (
            <></>
          )}
        </CSSTransition>
        {skipButton}
        {nextStepButton}
      </div>
    </section>
  )
}

export default ChecklistStep
